import Select from "../core/selector";
import { translate } from "../core/translate";

function attach(): void {
  Select.byClassAll("inline-prompt").forEach((element: HTMLElement) => {
    element.addEventListener("click", (e: MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      showInlinePrompt(e.currentTarget as HTMLButtonElement);
    });
  });
}

function showInlinePrompt(button: HTMLButtonElement): void {
  button.classList.add("d-none");

  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("btn-group", "p-relative");

  const acceptButton = document.createElement("button");
  acceptButton.formAction = button.formAction;
  acceptButton.dataset.bsToggle = "popover";
  acceptButton.dataset.bsPlacement = "top";
  acceptButton.dataset.bsContent = translate("Confirm deletion?");
  acceptButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
  <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
</svg>`;
  acceptButton.classList.add("btn", "btn-outline-success");


  var pp = new bootstrap.Popover(acceptButton);

  acceptButton.addEventListener("click", (e: MouseEvent) => {
    setTimeout(() => {
      buttonContainer.remove();
      button.classList.remove("d-none");
      pp.hide();
    }, 100);
  });

  const abortButton = document.createElement("button");
  abortButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg>`;
  abortButton.classList.add("btn", "btn-outline-danger");
  abortButton.addEventListener("click", (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    buttonContainer.remove();
    button.classList.remove("d-none");
    pp.hide();
  });

  buttonContainer.appendChild(acceptButton);
  buttonContainer.appendChild(abortButton);

  const parent = button.parentElement;
  parent?.appendChild(buttonContainer);

  pp.show();
}

attach();
